import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardMenuArrowMobile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 18, viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 17L9 8.86885L1 1", stroke: "#B0B0B0", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDashboardMenuArrowMobile);
export { ForwardRef as ReactComponent };
